export default function isEmptyOject(value: any): boolean {
  const isObject = typeof value === 'object';
  return isObject && Object.keys(value).length === 0;
}
